import type { VendorDto, VendorGridItemDto, VendorInputDto, VendorPagedRequestDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class VendorService {
  apiName = 'Default';
  

  createVendorByInputDto = (inputDto: VendorInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/vendor/vendor',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  deleteVendorByVendorId = (vendorId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/vendor/vendor/${vendorId}`,
    },
    { apiName: this.apiName,...config });
  

  editVendorByInputDto = (inputDto: VendorInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/vendor/edit-vendor',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  getAllVendorsByInput = (input: VendorPagedRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<VendorGridItemDto>>({
      method: 'GET',
      url: '/api/app/vendor/vendors',
      params: { name: input.name, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getVendorByVendorId = (vendorId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, VendorDto>({
      method: 'GET',
      url: `/api/app/vendor/vendor/${vendorId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
